
































import {
  Vue, Component, Prop, Watch, Mixins, Emit, PropSync,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import {
  contains, pickBy, values, map,
} from 'ramda'
import {
  update, field, collection, get, query, where, set, add, value,
} from 'typesaurus'
import {
  getModule,
} from 'vuex-module-decorators'
import md5 from 'md5'
import firebase from 'firebase'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import TaskStore from '../../store/modules/tasks'
import { db } from '../../firebase/init'
import { TaskType, CommentType, CustomerType } from '../../types'
import Comments from '../comments/Comments.vue'

@Component({
  components: {
    Comments,
  },
})
export default class SingleCustomer extends Mixins(MainMixin) {
  @Prop() data!:CustomerType

  @Prop({ default: true }) showComments!:boolean

  @Prop({ default: true }) showTags!:boolean

  get profile() {
    if (this.data) {
      if (this.data.profile) return this.data.profile
      const hash = md5(this.data.email)
      return `https://www.gravatar.com/avatar/${hash}?d=identicon&s=400`
    } return null
  }

  showAddComment = false

  loading = false

  newComment = ''

  get allTags() {
    const { tags } = this.$store.state.location.gData
    const isInList:any = (val:any) => contains(val.id, this.data.tags)
    const getValue = (val:any) => val.text
    return map(getValue, values(pickBy(isInList, tags) as object))
  }
  // async addComment() {
  //   this.loading = true
  //   console.log('Adding Comment: ', this.newComment)
  //   const comment:CommentType = { user: this.$store.getters.uid, comment: this.newComment, created: new Date() }
  //   const result = await update(Tasks, this.id, [field('comments', value('arrayUnion', [comment]))])
  //   console.log('result is: ', result)
  //   this.newComment = ''
  //   this.$toast.success('Comment Added!')
  //   this.loading = false
  // }
}

